// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 设置面板样式 */

.settings-panel {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid var(--gray-200);
}

.settings-panel h3 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 1.5rem;
}

.settings-panel h3 i {
  color: var(--mango-500);
}

.settings-content {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.setting-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.setting-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--gray-700);
}

.setting-label i {
  color: var(--leaf-500);
  width: 14px;
  text-align: center;
}

.crystal-select {
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.8);
  border: 2px solid var(--gray-200);
  border-radius: 8px;
  font-size: 0.875rem;
  color: var(--gray-800);
  cursor: pointer;
  transition: all var(--duration-normal) ease;
  font-family: var(--font-family);
}

.crystal-select:hover:not(:disabled) {
  border-color: var(--leaf-300);
  background: rgba(255, 255, 255, 0.95);
}

.crystal-select:focus {
  outline: none;
  border-color: var(--leaf-500);
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
}

.crystal-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: var(--gray-100);
}

.slider-container {
  position: relative;
}

.crystal-slider {
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(to right, var(--leaf-200), var(--leaf-500));
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  cursor: pointer;
}

.crystal-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--leaf-500);
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: all var(--duration-fast) ease;
}

.crystal-slider::-webkit-slider-thumb:hover {
  transform: scale(1.1);
  background: var(--leaf-600);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.crystal-slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--leaf-500);
  cursor: pointer;
  border: none;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: all var(--duration-fast) ease;
}

.crystal-slider::-moz-range-thumb:hover {
  transform: scale(1.1);
  background: var(--leaf-600);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.crystal-slider:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.crystal-slider:disabled::-webkit-slider-thumb {
  cursor: not-allowed;
  transform: none !important;
}

.slider-marks {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: var(--gray-500);
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: var(--gray-700);
  transition: color var(--duration-fast) ease;
}

.checkbox-label:hover:not(:has(input:disabled)) {
  color: var(--gray-900);
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--leaf-500);
  border-radius: 3px;
}

.checkbox-label input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.checkbox-label:has(input:disabled) {
  opacity: 0.6;
  cursor: not-allowed;
}

.settings-locked {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem;
  background: var(--lemon-50);
  border: 1px solid var(--lemon-200);
  border-radius: 8px;
  color: var(--lemon-700);
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 0.5rem;
}

.settings-locked i {
  color: var(--lemon-600);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .settings-panel {
    padding: 1rem;
  }
  
  .settings-content {
    gap: 1rem;
  }
  
  .setting-group {
    gap: 0.5rem;
  }
  
  .crystal-select {
    padding: 0.625rem 0.875rem;
    font-size: 0.8125rem;
  }
  
  .checkbox-group {
    gap: 0.5rem;
  }
  
  .checkbox-label {
    font-size: 0.8125rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SettingsPanel.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,oCAAoC;EACpC,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,uEAAuE;EACvE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* 设置面板样式 */\n\n.settings-panel {\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 12px;\n  padding: 1.5rem;\n  border: 1px solid var(--gray-200);\n}\n\n.settings-panel h3 {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 1.5rem;\n}\n\n.settings-panel h3 i {\n  color: var(--mango-500);\n}\n\n.settings-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.setting-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.setting-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--gray-700);\n}\n\n.setting-label i {\n  color: var(--leaf-500);\n  width: 14px;\n  text-align: center;\n}\n\n.crystal-select {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: rgba(255, 255, 255, 0.8);\n  border: 2px solid var(--gray-200);\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: var(--gray-800);\n  cursor: pointer;\n  transition: all var(--duration-normal) ease;\n  font-family: var(--font-family);\n}\n\n.crystal-select:hover:not(:disabled) {\n  border-color: var(--leaf-300);\n  background: rgba(255, 255, 255, 0.95);\n}\n\n.crystal-select:focus {\n  outline: none;\n  border-color: var(--leaf-500);\n  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);\n}\n\n.crystal-select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: var(--gray-100);\n}\n\n.slider-container {\n  position: relative;\n}\n\n.crystal-slider {\n  width: 100%;\n  height: 6px;\n  border-radius: 3px;\n  background: linear-gradient(to right, var(--leaf-200), var(--leaf-500));\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  cursor: pointer;\n}\n\n.crystal-slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--leaf-500);\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  transition: all var(--duration-fast) ease;\n}\n\n.crystal-slider::-webkit-slider-thumb:hover {\n  transform: scale(1.1);\n  background: var(--leaf-600);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.crystal-slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--leaf-500);\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  transition: all var(--duration-fast) ease;\n}\n\n.crystal-slider::-moz-range-thumb:hover {\n  transform: scale(1.1);\n  background: var(--leaf-600);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n.crystal-slider:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.crystal-slider:disabled::-webkit-slider-thumb {\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.slider-marks {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0.5rem;\n  font-size: 0.75rem;\n  color: var(--gray-500);\n}\n\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  color: var(--gray-700);\n  transition: color var(--duration-fast) ease;\n}\n\n.checkbox-label:hover:not(:has(input:disabled)) {\n  color: var(--gray-900);\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--leaf-500);\n  border-radius: 3px;\n}\n\n.checkbox-label input[type=\"checkbox\"]:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.checkbox-label:has(input:disabled) {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.settings-locked {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 1rem;\n  background: var(--lemon-50);\n  border: 1px solid var(--lemon-200);\n  border-radius: 8px;\n  color: var(--lemon-700);\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin-top: 0.5rem;\n}\n\n.settings-locked i {\n  color: var(--lemon-600);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .settings-panel {\n    padding: 1rem;\n  }\n  \n  .settings-content {\n    gap: 1rem;\n  }\n  \n  .setting-group {\n    gap: 0.5rem;\n  }\n  \n  .crystal-select {\n    padding: 0.625rem 0.875rem;\n    font-size: 0.8125rem;\n  }\n  \n  .checkbox-group {\n    gap: 0.5rem;\n  }\n  \n  .checkbox-label {\n    font-size: 0.8125rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
